/* Guía de tallas "Trova la tua taglia" + acordeón "Tabella taglie" (v2, pedido Igor 2026-10-16).
   Datos: metafield de producto custom.tabla_taglie (JSON) -> snippets/stylesheets.liquid lo escribe en window.MF_SIZE.
   Formato JSON: {"head":["Taglia","IT","EU","Seno","Vita","Fianchi"],"rows":[["S",40,36,"84-88","66-70","92-96"],...],
   "basis":"body"|"garment" (def. body),"ease":6 (solo garment),"meas":[{"k":"bust","c":3},...] (opcional: se deduce de la cabecera),"note":"..."}.
   Cabeceras reconocidas: Seno/Busto/Torace/Petto=bust, Vita=waist, Fianchi=hips, Piede=foot (EU/UK/US/IT son solo informativas).
   El medidor (altura+peso) estima las medidas del cuerpo y las compara con las columnas de medida de la tabla del producto.
   Sin metafield: tablas antiguas por colección (FALLBACK), con el mismo resultado que el baremo anterior. */
(function (root) {
  'use strict';

  var FALLBACK = [
    { cols: ['giacche','giacche trapuntate stampate','giacche vintage','abiti','top e camicie','completi in maglia','cappotti'],
      head: ['Taglia','IT','EU','Seno','Vita','Fianchi'],
      rows: [['XS',38,34,'80-84','62-66','88-92'],['S',40,36,'84-88','66-70','92-96'],['M',42,38,'88-92','70-74','96-100'],['L',44,40,'92-96','74-78','100-104'],['XL',46,42,'96-100','78-82','104-108'],['2XL',48,44,'100-104','82-86','108-112'],['3XL',50,46,'104-108','86-90','112-116'],['4XL',52,48,'108-112','90-94','116-120'],['5XL',54,50,'112-116','94-98','120-124']],
      note: 'Per cappotti e giacche, se vuoi indossare un maglione sotto, scegli una taglia in più.' },
    { cols: ['pantaloni e gonne','gonne','pantaloni'],
      head: ['Taglia','IT','EU','Vita','Fianchi'],
      rows: [['XS',38,34,'62-66','88-92'],['S',40,36,'66-70','92-96'],['M',42,38,'70-74','96-100'],['L',44,40,'74-78','100-104'],['XL',46,42,'78-82','104-108'],['2XL',48,44,'82-86','108-112'],['3XL',50,46,'86-90','112-116'],['4XL',52,48,'90-94','116-120'],['5XL',54,50,'94-98','120-124']],
      note: 'Tessuto elasticizzato: veste comoda anche tra due taglie.' },
    { cols: ['scarpe','scarpe comode','stivali','tacchi','mocassini e ballerine','sandali'],
      head: ['EU','UK','US','Piede (cm)'],
      rows: [['35',2.5,4.5,22.3],['36',3.5,5.5,23.0],['37',4,6,23.7],['38',5,7,24.3],['39',6,8,25.0],['40',6.5,8.5,25.7],['41',7.5,9.5,26.3],['42',8,10,27.0]],
      note: 'Appoggia il piede su un foglio, segna tallone e punta dell\'alluce e misura la distanza. Se sei tra due misure, scegli la più grande.' }
  ];

  /* Modelo cuerpo: IMC -> medidas estimadas. Puntos de anclaje = límite superior de cada talla de la tabla estándar,
     de modo que con la tabla estándar el resultado es idéntico al baremo anterior (límites IMC 18,5/20/23,5/25,5/28/30,5/33,5/37). */
  var BMIX = [18.5, 20, 23.5, 25.5, 28, 30.5, 33.5, 37];
  var ANCHORS = {
    bust:  [84, 88, 92, 96, 100, 104, 108, 112],
    waist: [66, 70, 74, 78, 82, 86, 90, 94],
    hips:  [92, 96, 100, 104, 108, 112, 116, 120]
  };
  var TALL = 178;       /* altura desde la que se sube 1 talla */
  var EASE = 6;         /* holgura (cm) sobre el cuerpo cuando la tabla es de prenda (basis "garment") */

  function est(k, b) {
    var X = BMIX, Y = ANCHORS[k], n = X.length, i;
    if (b <= X[0]) return Y[0] + (b - X[0]) * (Y[1] - Y[0]) / (X[1] - X[0]);
    for (i = 1; i < n; i++) if (b <= X[i]) return Y[i - 1] + (b - X[i - 1]) * (Y[i] - Y[i - 1]) / (X[i] - X[i - 1]);
    return Y[n - 1] + (b - X[n - 1]) * (Y[n - 1] - Y[n - 2]) / (X[n - 1] - X[n - 2]);
  }
  function rng(c) {
    var s = String(c).replace(/,/g, '.').replace(/[–—]/g, '-');
    var m = s.match(/(\d+(?:\.\d+)?)(?:\s*-\s*(\d+(?:\.\d+)?))?/);
    if (!m) return null;
    var a = parseFloat(m[1]), b = m[2] != null ? parseFloat(m[2]) : a;
    return { lo: Math.min(a, b), hi: Math.max(a, b) };
  }
  function infer(t) {
    if (t.meas && t.meas.length) return t.meas;
    var out = [];
    (t.head || []).forEach(function (h, c) {
      var s = String(h).toLowerCase();
      var k = /seno|busto|torace|petto/.test(s) ? 'bust' : /vita/.test(s) ? 'waist' : /fianch/.test(s) ? 'hips' : /piede|plantare/.test(s) ? 'foot' : null;
      if (k) out.push({ k: k, c: c });
    });
    return out;
  }
  /* Devuelve la tabla normalizada o null si no es utilizable (entonces se usa el fallback). */
  function normalize(t) {
    if (!t || !Array.isArray(t.head) || !Array.isArray(t.rows) || t.rows.length < 2) return null;
    var meas = infer(t), ok = meas.length > 0, i;
    meas.forEach(function (m) {
      if (!(m.k in ANCHORS) && m.k !== 'foot') ok = false;
      if (m.c == null || m.c < 1 || m.c >= t.head.length) ok = false;
    });
    if (!ok) return null;
    for (i = 0; i < t.rows.length; i++) {
      if (!Array.isArray(t.rows[i]) || t.rows[i].length !== t.head.length) return null;
      for (var j = 0; j < meas.length; j++) if (!rng(t.rows[i][meas[j].c])) return null;
    }
    var shoe = meas.some(function (m) { return m.k === 'foot'; });
    if (shoe && meas.length > 1) meas = meas.filter(function (m) { return m.k === 'foot'; });
    return { head: t.head, rows: t.rows, meas: meas, kind: shoe ? 'shoe' : 'wear', basis: t.basis === 'garment' ? 'garment' : 'body',
      ease: typeof t.ease === 'number' ? t.ease : EASE, note: t.note || '' };
  }

  function recommend(tbl, s) {
    var n = tbl.rows.length, idx = 0, i, r;
    if (tbl.kind === 'shoe') {
      var fc = tbl.meas[0].c; idx = n - 1;
      for (i = 0; i < n; i++) { r = rng(tbl.rows[i][fc]); if (r && r.hi >= s.foot - 0.001) { idx = i; break; } }
    } else {
      var b = s.w / Math.pow(s.h / 100, 2), gar = tbl.basis === 'garment';
      tbl.meas.forEach(function (m) {
        var need = est(m.k, b) + (gar ? tbl.ease : 0), j = n - 1, k;
        for (k = 0; k < n; k++) { r = rng(tbl.rows[k][m.c]); if (r && (gar ? r.hi >= need : r.hi > need)) { j = k; break; } }
        if (j > idx) idx = j;
      });
      if (s.h >= TALL) idx += 1;
    }
    if (s.usual != null) idx = Math.ceil((idx + s.usual) / 2);
    if (s.wide) idx += 1;
    return Math.max(0, Math.min(n - 1, idx));
  }

  if (typeof document === 'undefined') { root.exports = { FALLBACK: FALLBACK, normalize: normalize, recommend: recommend, rng: rng, est: est }; return; }

  /* ---------- Interfaz (tienda) ---------- */
  if (window.__mfGT) return; window.__mfGT = true;
  var ICON = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 17 17 3l4 4L7 21z"/><path d="M7.5 12.5l2 2M10.5 9.5l2 2M13.5 6.5l2 2"/></svg>';
  var tbl = null, ov = null, st = {}, wasOpen = false;

  function pickTable() {
    var own = normalize(window.MF_SIZE);
    if (own) { own.own = true; return own; }
    var cols = (window.MF_GT_COLS || []).map(function (c) { return String(c).toLowerCase().trim(); });
    for (var i = 0; i < FALLBACK.length; i++) {
      for (var j = 0; j < FALLBACK[i].cols.length; j++) if (cols.indexOf(FALLBACK[i].cols[j]) > -1) return normalize(FALLBACK[i]);
    }
    return null;
  }
  function norm(t) {
    t = String(t || '').toUpperCase().replace(/\s+/g, '');
    var m = t.match(/^(X{2,5})L$/); if (m) return m[1].length + 'XL';
    return t;
  }
  function prodSizes() {
    var out = [];
    document.querySelectorAll('mf-product-information [data-is-size="true"] .mf-choice--size').forEach(function (c) {
      var inp = c.querySelector('input'), lb = c.querySelector('label');
      if (!inp || !lb) return;
      var label = lb.textContent.trim();
      out.push({ label: label, key: norm(label), input: inp, ok: inp.getAttribute('data-available') !== 'false' });
    });
    return out;
  }
  function rowIndexFor(key) {
    var itc = -1;
    tbl.head.forEach(function (h, c) { if (String(h).toUpperCase() === 'IT') itc = c; });
    for (var i = 0; i < tbl.rows.length; i++) {
      var r = tbl.rows[i];
      if (norm(r[0]) === key) return i;
      if (tbl.kind === 'wear' && itc > 0 && /^\d+$/.test(key) && String(r[itc]) === key) return i;
    }
    return -1;
  }
  function f(c) { return String(c).replace('.', ','); }
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }

  function build() {
    ov = el('div', 'gt-ov');
    ov.setAttribute('role', 'dialog'); ov.setAttribute('aria-modal', 'true'); ov.setAttribute('aria-label', 'Trova la tua taglia');
    document.body.appendChild(ov);
    ov.addEventListener('click', function (e) { if (e.target === ov) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && ov.classList.contains('open')) close(); });
  }

  function slider(id, label, unit, min, max, step, val) {
    return '<div class="gt-f"><div class="gt-lb"><span>' + label + '</span><span class="gt-val"><output id="' + id + 'o">' + val + '</output> ' + unit + '</span></div>' +
      '<div class="gt-rg"><button type="button" class="gt-st" data-st="' + id + '" data-d="-1" aria-label="Meno">−</button>' +
      '<input type="range" id="' + id + '" min="' + min + '" max="' + max + '" step="' + step + '" value="' + val + '" aria-label="' + label + '">' +
      '<button type="button" class="gt-st" data-st="' + id + '" data-d="1" aria-label="Più">+</button></div></div>';
  }

  function render() {
    var sizes = prodSizes(), shoe = tbl.kind === 'shoe';
    st = { usual: null, wide: 0, sizes: sizes, sel: null };
    var usualChips = '';
    sizes.forEach(function (s) { var ri = rowIndexFor(s.key); if (ri > -1) usualChips += '<button type="button" data-u="' + ri + '" aria-pressed="false">' + s.label + '</button>'; });
    var fm = '<div class="gt-frm"><h4 class="gt-h">Trova la tua taglia</h4><p class="gt-sub">' + (shoe ? 'Dimmi quanto è lungo il tuo piede e ti consiglio la misura giusta.' : 'Dimmi altezza e peso: ti consiglio la taglia in 20 secondi.') + '</p>';
    if (shoe) {
      fm += slider('gt-foot', 'Lunghezza del piede', 'cm', 21.5, 28, 0.1, 24.5);
    } else {
      fm += slider('gt-h', 'Altezza', 'cm', 140, 195, 1, 165) + slider('gt-w', 'Peso', 'kg', 40, 140, 1, 65);
    }
    if (usualChips) fm += '<div class="gt-f"><div class="gt-lb"><span>Taglia che porti di solito</span><i>facoltativo</i></div><div class="gt-chips" data-g="usual">' + usualChips + '</div></div>';
    fm += '<div class="gt-f"><div class="gt-lb"><span>Vestibilità preferita</span><i>facoltativo</i></div><div class="gt-chips" data-g="fit"><button type="button" data-f="0" aria-pressed="true">Normale</button><button type="button" data-f="1" aria-pressed="false">Più comoda</button></div></div>';
    fm += '<button type="button" class="gt-go">Trova la mia taglia</button></div>';
    var r = '<div class="gt-res"><div class="gt-big" data-r="big"></div><p class="gt-t">Ti consigliamo</p><p class="gt-d" data-r="d"></p><button type="button" class="gt-sel" data-r="sel"></button>' +
      '<button type="button" class="gt-lk" data-r="back">Modifica le misure</button><button type="button" class="gt-lk" data-r="tab">Vedi la tabella completa</button><div class="gt-tb" data-r="tb"></div></div>';
    ov.innerHTML = '<div class="gt-pn"><button type="button" class="gt-x" aria-label="Chiudi">×</button>' + fm + r + '<p class="gt-note">Consiglio indicativo. Se sei indecisa tra due taglie, scegli la più grande.</p></div>';
    wire();
  }

  function wire() {
    var pn = ov.querySelector('.gt-pn');
    pn.querySelector('.gt-x').addEventListener('click', close);
    pn.querySelectorAll('input[type=range]').forEach(function (inp) {
      inp.addEventListener('input', function () { pn.querySelector('#' + inp.id + 'o').textContent = inp.value; });
    });
    pn.querySelectorAll('.gt-st').forEach(function (b) {
      b.addEventListener('click', function () {
        var inp = pn.querySelector('#' + b.dataset.st), stp = parseFloat(inp.step) || 1;
        var v = Math.round((parseFloat(inp.value) + stp * parseInt(b.dataset.d, 10)) * 10) / 10;
        inp.value = Math.max(inp.min, Math.min(inp.max, v)); inp.dispatchEvent(new Event('input'));
      });
    });
    pn.querySelectorAll('[data-g] button').forEach(function (b) {
      b.addEventListener('click', function () {
        var grp = b.parentNode, on = b.getAttribute('aria-pressed') === 'true';
        if (grp.dataset.g === 'fit') { grp.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); }); b.setAttribute('aria-pressed', 'true'); st.wide = parseInt(b.dataset.f, 10); return; }
        grp.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        if (!on) { b.setAttribute('aria-pressed', 'true'); st.usual = parseInt(b.dataset.u, 10); } else st.usual = null;
      });
    });
    pn.querySelector('.gt-go').addEventListener('click', function () { calc(pn); });
    pn.querySelector('[data-r=back]').addEventListener('click', function () { pn.classList.remove('done'); });
    pn.querySelector('[data-r=tab]').addEventListener('click', function () { pn.querySelector('[data-r=tb]').classList.toggle('open'); });
    pn.querySelector('[data-r=sel]').addEventListener('click', function () {
      if (st.sel && st.sel.ok) { st.sel.input.click(); close(); }
    });
  }

  function calc(pn) {
    var shoe = tbl.kind === 'shoe', s = { usual: st.usual, wide: st.wide };
    if (shoe) s.foot = parseFloat(pn.querySelector('#gt-foot').value);
    else { s.h = parseFloat(pn.querySelector('#gt-h').value); s.w = parseFloat(pn.querySelector('#gt-w').value); }
    var idx = recommend(tbl, s), label = tbl.rows[idx][0], sizes = st.sizes = prodSizes();
    var by = {}; sizes.forEach(function (x) { var ri = rowIndexFor(x.key); if (ri > -1) by[ri] = x; });
    var chosen = by[idx], msg;
    if (!chosen || !chosen.ok) {
      var alt = null;
      for (var up = idx + 1; up < tbl.rows.length && !alt; up++) if (by[up] && by[up].ok) alt = by[up];
      for (var dn = idx - 1; dn >= 0 && !alt; dn--) if (by[dn] && by[dn].ok) alt = by[dn];
      var nm = shoe ? 'La misura ' : 'La taglia ';
      msg = chosen ? nm + label + ' al momento non è disponibile per questo articolo.' : nm + label + ' non è prevista per questo articolo.';
      if (alt) msg += ' La più vicina disponibile è la ' + alt.label + '.';
      chosen = alt;
    } else {
      msg = shoe ? 'Per un piede di ' + String(s.foot).replace('.', ',') + ' cm la misura ' + label + ' è la più adatta.'
        : 'Per ' + s.h + ' cm e ' + s.w + ' kg la taglia ' + label + ' è la più adatta.';
    }
    if (st.wide && chosen) msg += ' Abbiamo considerato la vestibilità più comoda.';
    st.sel = chosen;
    var show = chosen ? chosen.label : label;
    pn.querySelector('[data-r=big]').textContent = chosen ? chosen.label : label;
    pn.querySelector('[data-r=big]').style.fontSize = String(show).length > 3 ? '34px' : '';
    pn.querySelector('[data-r=d]').textContent = msg;
    var sel = pn.querySelector('[data-r=sel]');
    sel.style.display = chosen ? '' : 'none';
    if (chosen) sel.textContent = (shoe ? 'Seleziona la misura ' : 'Seleziona la taglia ') + chosen.label;
    var t = '<table><tr>' + tbl.head.map(function (h) { return '<th>' + h + '</th>'; }).join('') + '</tr>' +
      tbl.rows.map(function (r, i) { return '<tr' + (i === idx ? ' class="on"' : '') + '>' + r.map(function (c) { return '<td>' + f(c) + '</td>'; }).join('') + '</tr>'; }).join('') + '</table>' +
      (tbl.note ? '<p class="gt-note">' + tbl.note + '</p>' : '');
    pn.querySelector('[data-r=tb]').innerHTML = t;
    pn.querySelector('[data-r=tb]').classList.remove('open');
    pn.classList.add('done'); pn.scrollTop = 0;
  }

  function open() {
    if (!ov) build();
    render();
    ov.classList.add('open'); document.documentElement.classList.add('gt-lock');
    var x = ov.querySelector('.gt-x'); if (x) x.focus();
    try { window.dataLayer && window.dataLayer.push({ event: 'size_finder_open' }); } catch (e) {}
  }
  function close() { if (ov) ov.classList.remove('open'); document.documentElement.classList.remove('gt-lock'); }

  function inject() {
    if (!tbl) return;
    document.querySelectorAll('mf-product-information [data-kiwi-guide-slot]:not([data-gt])').forEach(function (slot) {
      slot.setAttribute('data-gt', '1');
      var b = el('button', 'gt-link', ICON + 'Trova la tua taglia'); b.type = 'button';
      b.addEventListener('click', open);
      slot.insertBefore(b, slot.firstChild);
    });
  }

  /* Acordeón "Tabella taglie" con la tabla del producto (metafield). Sustituye al de assets/tabla-fotos-claude.js (tabla por colección). */
  function tableHTML() {
    return '<div class="mf-tt"><div class="mf-tt__w"><table><thead><tr>' + tbl.head.map(function (h) { return '<th>' + h + '</th>'; }).join('') + '</tr></thead><tbody>' +
      tbl.rows.map(function (r) { return '<tr>' + r.map(function (c, i) { return i === 0 ? '<td><b>' + c + '</b></td>' : '<td>' + f(c) + '</td>'; }).join('') + '</tr>'; }).join('') +
      '</tbody></table></div><p class="mf-tt__f">Per sapere esattamente la tua taglia, vai a <a role="button" tabindex="0" data-tt-link>«Trova la tua taglia»</a></p></div>';
  }
  document.addEventListener('toggle', function (e) {
    var t = e.target; if (t && t.matches && t.matches('[data-accordion="taglie"]')) wasOpen = t.open;
  }, true);
  function putTable() {
    if (!tbl || !tbl.own) return;
    document.querySelectorAll('mf-product-information').forEach(function (r) {
      var acc = r.querySelector('.mf-accordions'); if (!acc) return;
      var cur = acc.querySelector('[data-accordion="taglie"]');
      if (cur && cur.getAttribute('data-own')) return;
      var d = document.createElement('details'); d.setAttribute('data-accordion', 'taglie'); d.setAttribute('data-own', '1');
      d.innerHTML = '<summary>Tabella taglie<span class="mf-chevron" aria-hidden="true"></span></summary><div class="mf-richtext"><div class="mf-richtext-inner">' + tableHTML() + '</div></div>';
      if (cur) { if (cur.open) wasOpen = true; cur.replaceWith(d); }
      else {
        var desc = acc.querySelector('[data-accordion="description"]');
        if (desc && desc.nextSibling) acc.insertBefore(d, desc.nextSibling); else acc.appendChild(d);
      }
      if (wasOpen) d.open = true;
      d.querySelectorAll('tbody tr').forEach(function (tr) {
        tr.style.cursor = 'pointer';
        tr.addEventListener('click', function () { var on = tr.classList.contains('on'); d.querySelectorAll('tr.on').forEach(function (x) { x.classList.remove('on'); }); if (!on) tr.classList.add('on'); });
      });
      var a = d.querySelector('[data-tt-link]');
      function go(ev) { ev.preventDefault(); var b = document.querySelector('mf-product-information .gt-link'); if (b) b.click(); }
      a.addEventListener('click', go);
      a.addEventListener('keydown', function (ev) { if (ev.key === 'Enter' || ev.key === ' ') go(ev); });
    });
  }

  function init() {
    tbl = pickTable(); if (!tbl) return;
    inject(); putTable();
    var q = false;
    new MutationObserver(function () { if (q) return; q = true; requestAnimationFrame(function () { q = false; inject(); putTable(); }); }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})(typeof module !== 'undefined' ? module : this);
